<template>
  <div class="about">
    <h1>404 - Not found</h1>
    <p>This page doesn't exist or have been moved</p>
  </div>
</template>
